<template>
  <div class="acts-editor-costs">
    <divider orientation="left">Сведения о сумме акта и оплате</divider>
    <div class="acts-editor-costs__amount ms-help">
      Общая сумма по акту:
      <b>{{ getFormattedCosts(roadmapCosts, false, withVat) }}</b>
    </div>
    <div class="acts-editor-state__payments-status" v-if="act.id">
      <div class="acts-editor-state__payment-row ms-help">
        Оплачено по акту:
        <b>{{ getFormattedCosts(act.payments, false, withVat) }}</b>
      </div>
      <div class="acts-editor-state__payment-row ms-help">
        Долг по акту:
        <b>{{ getFormattedCosts(act.debt_payments, false, withVat) }}</b>
      </div>
    </div>
  </div>
</template>

<script>
import { getFormattedCosts } from '@/utils'

export default {
  props: ['act', 'roadmap'],
  computed: {
    withVat () {
      return this.$store.state.contracts.current.with_vat
    },
    roadmapCosts () {
      return this.act.act_roadmaps
        .filter(r => !r.disabled)
        .reduce((prev, el) => prev + el.costs, 0)
    }
  },
  methods: {
    getFormattedCosts
  }
}
</script>

<style lang="less">
.acts-editor-costs {
  &__amount {
    margin-bottom: 8px;
  }
}
</style>
